// Shared video URL helpers. Previously duplicated in Workouts.jsx and WorkoutDetail.jsx.

// Turns a Google Drive / YouTube share link into something we can drop in an iframe.
// Anything we don't recognise is returned untouched.
export const formatVideoUrl = (url, options = {}) => {
  if (!url) return null;

  const { autoplay = false, loop = false } = options;

  // Handle Google Drive URLs
  if (url.includes('drive.google.com')) {
    // Extract the file ID from the URL
    const fileIdMatch = url.match(/[-\w]{25,}/);
    if (fileIdMatch && fileIdMatch[0]) {
      const fileId = fileIdMatch[0];
      return `https://drive.google.com/file/d/${fileId}/preview`;
    }
  }

  // Handle YouTube URLs
  if (url.includes('youtube.com') || url.includes('youtu.be')) {
    let videoId;

    // Full youtube.com URL
    if (url.includes('youtube.com/watch')) {
      const urlParams = new URLSearchParams(url.split('?')[1]);
      videoId = urlParams.get('v');
    }
    // Shortened youtu.be URL
    else if (url.includes('youtu.be')) {
      videoId = url.split('/').pop();
    }

    if (videoId) {
      const params = new URLSearchParams({ rel: '0', modestbranding: '1' });
      // Browsers only allow programmatic playback when it's muted.
      if (autoplay) {
        params.set('autoplay', '1');
        params.set('mute', '1');
      }
      // YouTube needs the video listed as its own playlist for loop to work.
      if (loop) {
        params.set('loop', '1');
        params.set('playlist', videoId);
      }
      return `https://www.youtube.com/embed/${videoId}?${params.toString()}`;
    }
  }

  // Return the original URL if we couldn't format it
  return url;
};

export default formatVideoUrl;
